import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import React from "react";
import gameFinalizeStyles from "../../team/styles/GameFinalize.styles";
import Team from "../../team/components/Team";

const TeamRecords = ({
	team = {},
	handleChange,
	values = {},
	errors = {},
	touched = {}
}) => {
	const { id } = team;
	const classes = gameFinalizeStyles();

	return (
		<>
			<Grid item xs={12} className={classes.team}>
				<Team team={team} textVariant="h5" />
			</Grid>
			<Grid item xs={12} md={6}>
				<TextField
					fullWidth
					variant="outlined"
					id={`records[${id}].overall`}
					name={`records[${id}].overall`}
					label="Overall Record"
					value={values.overall}
					error={touched.overall && errors.overall}
					helperText={touched.overall && errors.overall}
					onChange={handleChange}
				/>
			</Grid>
			<Grid item xs={12} md={6}>
				<TextField
					fullWidth
					variant="outlined"
					id={`records[${id}].conference`}
					name={`records[${id}].conference`}
					label="Conference Record"
					value={values.conference}
					error={touched.conference && errors.conference}
					helperText={touched.conference && errors.conference}
					onChange={handleChange}
				/>
			</Grid>
		</>
	);
};

export default TeamRecords;
